import React, {useState} from 'react';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Pagination from 'react-bootstrap/Pagination';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Offcanvas from 'react-bootstrap/Offcanvas';
import OffcanvasHeader from 'react-bootstrap/OffcanvasHeader';
import OffcanvasTitle from 'react-bootstrap/OffcanvasTitle';
import OffcanvasBody from 'react-bootstrap/OffcanvasBody';
import PhotoLoader from './components/PhotoLoader/PhotoLoader';

function App() {

	  const [show, setShow] = useState(false);
	  
	  function OffCanvas() {
		  
	  const [show, setShow] = useState(false);

	  const handleClose = () => setShow(false);
	  const handleShow = () => setShow(true);

	  return (
		<>
		  <Button variant="primary" onClick={handleShow} className="me-2">
			Info
		  </Button>
		  <Offcanvas show={show} onHide={handleClose}>
			<Offcanvas.Header closeButton>
			  <Offcanvas.Title>Info</Offcanvas.Title>
			</Offcanvas.Header>
			<Offcanvas.Body>
			  <strong>Photobrowser</strong><br /><br />
			  <p>This is an Application for loading photos from Cross-Site URL via Axios (AJAX module for React).</p>
			  <strong>License</strong><br /><br />
			  <p>Copyright &copy; 2021-present i4ware Software</p>

			  <p>Permission is hereby granted, free of charge, to any person obtaining a copy
			     of this software and associated documentation files (the "Software"), to deal
			     in the Software without restriction, including without limitation the rights
			     to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
			     copies of the Software, and to permit persons to whom the Software is
			     furnished to do so, subject to the following conditions:</p>

			  <p>The above copyright notice and this permission notice shall be included in
			     all copies or substantial portions of the Software.</p>

			  <p>THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
			    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
			    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
			    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
			    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
			    THE SOFTWARE.</p>
			</Offcanvas.Body>
		  </Offcanvas>
		</>
	  );
	};
	 
  return (
    <div className="App">
	  <header className="App-header">
	    <img src={logo} className="App-logo" alt="logo" />
	  </header>
	  <main className="App-main">
		<div className="card App-photobrowser">
		  <div className="App-photobrowser-toolbar">
		  <h1>Photobrowser</h1>
		    <div className="App-canvas-button-right">
		      {['start'].map((placement, idx) => (
			    <OffCanvas key={idx} />
			  ))}
		    </div>
			<div className="clear"></div>			
		  </div>
			<PhotoLoader />
		</div>
	  </main>
	  <footer className="App-footer"></footer>
	</div>
  );
}

export default App;
